module.exports = __webpack_public_path__ + "static/media/data-sharing.aef27b25.svg";